/* eslint-disable */
'use strict';
exports.__esModule = true;
exports.default = {
  "ERP_list": "ERP列表",
  "ERP_qty": "ERP数量",
  "account": "帐户",
  "active": "状态",
  "active_date": "有效日期",
  "address": "地址",
  "address2": "地址(选填)",
  "amount": "金额",
  "and": "和",
  "buyer": "买家",
  "buyer_info": "买家信息",
  "cancel": "返回",
  "cancel_input": "取消输入",
  "canceled": "已取消",
  "cell_phone": "手机号码",
  "cellphone": "手机",
  "change_password": "更改密码",
  "city": "城市",
  "clear": "清除",
  "close_the_page_without_saving": "未保存确认关闭页面吗？",
  "company": "公司",
  "completed": "已完成",
  "confirm_password": "确认密码",
  "country": "国家",
  "create": "创建",
  "create_account": "创建帐户",
  "created_date": "创建日期",
  "created_success": "创建成功",
  "creationdate": "创建日期",
  "currency": "货币",
  "dash_board": "仪表板",
  "dealer": "经销商",
  "delete": "删除",
  "delete_success": "删除成功",
  "delete_tip1": "是否确认删除？",
  "delete_tip2": "",
  "description": "说明",
  "disable": "禁用",
  "disabled_success": "禁用成功",
  "edit": "编辑",
  "email": "邮箱",
  "enable": "启用",
  "enabled_success": "启用成功",
  "enter_character": "输入图片中的字符",
  "enter_confirm_password": "请再次输入新密码",
  "enter_new_password": "请输入新密码",
  "enter_old_password": "请输入旧密码",
  "enter_the_password_and_new_password": "请先输入密码和新密码！",
  "erp_list": "订阅列表",
  "erp_status": "状态",
  "error": "错误",
  "exp_date": "过期日期",
  "expire_date": "到期日",
  "first_name": "名",
  "forget_password": "忘记密码",
  "forgot_password": "忘记密码了？",
  "group_code": "小组编号",
  "history_order_list": "历史订单列表",
  "home_company_address": "家庭/公司地址",
  "image": "图像",
  "initial_info": "初始信息",
  "input_password_again": "请再次输入密码",
  "last_name": "姓",
  "launch_success": "上架成功",
  "legal_perssion": "法人",
  "logout": "退出登录",
  "mail": "邮箱",
  "modify": "修改",
  "modify_order_": "修改订单-",
  "modify_password": "修改密码",
  "modify_product": "修改产品",
  "modify_success": "修改成功",
  "module_ID": "模块ID",
  "modules": "模块",
  "moneyNumber_format_error": "金额大小错误",
  "money_format_error": "金额格式错误",
  "name": "名称",
  "new": "新增",
  "new_password": "新密码",
  "new_password_toEmail": "我们已经发送了一个新密码到你邮箱",
  "new_product": "新增产品",
  "next": "下一个",
  "noFoundurl1": "实例不存在",
  "number_of_users": "用户数量",
  "off_the_shelf": "下架",
  "official_website": "官方网站：",
  "ok": "好",
  "old_password": "旧密码",
  "old_password_error": "旧密码不匹配",
  "on_the_shelf": "上架",
  "operation": "操作",
  "or": "或",
  "order": "订单号",
  "order-no": "订单号",
  "order_": "订单-",
  "order_list": "订单列表",
  "order_no": "订单编号",
  "order_status": "订单状态",
  "paid": "已支付",
  "password": "密码",
  "password_error_two": "两次输入密码不一致！",
  "password_least": "密码至少6位且包含数字和字母/特殊字符",
  "password_must_be_the_same": "确认密码必须与重置密码一致！",
  "pay": "支付",
  "pay_status": "支付状态",
  "payment_date": "付款日期",
  "personal": "个人",
  "please_email": "发送了密码检索邮件，请注意接收邮件",
  "please_sign_in_again": "未经授权或已过期，请重新登录。",
  "pos": "序号",
  "price": "价格",
  "privacy": "通过创建SOMATIME账户，我理解并同意SOMATIME的",
  "privacy_notice": "隐私声明",
  "product": "产品",
  "product_list": "产品列表",
  "product_name": "产品名称",
  "refunded": "已退款",
  "registered_email_address": "我们已注册您的邮箱",
  "remove_success": "下架成功",
  "repeat_password": "重复密码",
  "required": "必填",
  "reseller": "经销商",
  "resend": "重发",
  "revoke": "撤销",
  "role": "类型",
  "search": "查找",
  "send_update": "从SOMATIME向我发送更新",
  "sex": "性别",
  "signIn": "登录",
  "state": "州/省",
  "status": "状态",
  "status_discrepancy": "状态不符",
  "submit": "提交",
  "submitted": "已提交",
  "subscribe-mon": "月订阅量",
  "subscribe_mon": "订阅月数",
  "success": "成功",
  "sure_to_close": "确认关闭?",
  "telephone": "电话",
  "tenant_list": "租户列表",
  "tenant_management_system": "租户管理系统",
  "tenant_system": "租户系统",
  "terms_of_use": "使用条款",
  "test": "测试",
  "title": "称呼",
  "unpaid": "未支付",
  "update_password_success": "密码修改成功",
  "user": "用户",
  "user_check": "请先阅读并勾选同意隐私声明和使用条款",
  "user_id": "用户编码",
  "user_information": "用户信息",
  "user_list": "用户列表",
  "user_month": "用户/月",
  "user_password_error": "您的用户名或密码错误！",
  "user_qty": "用户数量",
  "username": "用户名",
  "welcome_to_iceq": "欢迎来到SOMATIME",
  "wrong_user_name_and_password": "用户名密码错！",
  "zip": "邮编",
  "trial": "试用",
  "requesting_a_trial": "正在申请试用",
  "trial_orders_have_been_requested": "已申请过试用",
  "trial_orders_requested_success": "试用申请已通过",
  "apply_trial": "申请试用",
  "on_trial": "试用中",
  "order_not_exist": "订单不存在",
  "application_approved": "通过申请",
  "wait_for_payment": "待付款",
  "instCount": "实例数量",
  "trial_orders_requested_reject": "试用申请已拒绝",
  "application_reject": "拒绝申请",
  "trial_reject": "拒绝试用",
};